import { RecoQueryParameters } from "./fetchRecommendations";
import EntdCarouselContainer from "./EntdCarouselContainer";
import { entdCarouselContainerTagName } from "./entdCarouselContainerTagName";
import { PersonalisierungConsent, RichRelevanceConsent } from "./RecoConsent";

export type RecoLoaderProps = {
  placement: string | null;
  countryUrlPrefix: string | null;
  queryParameters: RecoQueryParameters;
  aktionsFlagsEnabled: boolean;
};

export default abstract class RecoLoader extends HTMLElement {
  protected recoLoaderProps: RecoLoaderProps | undefined;
  protected richRelevanceConsent: RichRelevanceConsent =
    false as RichRelevanceConsent;
  protected personalisierungConsent: PersonalisierungConsent =
    false as PersonalisierungConsent;
  private entdCarouselContainer: EntdCarouselContainer | null | undefined;
  protected campAktionsflagsInitialized: CustomEvent = new CustomEvent(
    "camp:aktionsflags:initialized",
  );

  connectedCallback(): void {
    window.requestAnimationFrame(() => {
      // This is placed inside a request animation frame because the connected callback is called when the custom element
      // tags is in the DOM but not all child element might have been parsed yet.
      // See https://stackoverflow.com/a/69389780
      this.entdCarouselContainer = this.querySelector<EntdCarouselContainer>(
        entdCarouselContainerTagName,
      );
    });
    this.getRecoParametersFromDataAttributes();
  }

  private getRecoParametersFromDataAttributes(): void {
    const placement = this.getAttribute("placement");
    const countryUrlPrefix = this.getAttribute("country-url-prefix");
    const syan = this.getAttribute("syan");
    const farbId = this.getAttribute("farb-id");
    const categoryId = this.getAttribute("category-id");
    const produktGruppe = this.getAttribute("produkt-gruppe");
    const markenName = this.getAttribute("marken-name");
    const searchterm = this.getAttribute("searchterm");
    const orderId = this.getAttribute("order-id");
    const cartpos = this.getAttribute("cartpos");
    const inCart = this.getAttribute("in-cart");
    const useMock = this.getAttribute("useMock");
    const aktionsFlagsEnabled = this.hasAttribute("aktionsFlagsEnabled");

    this.recoLoaderProps = {
      placement,
      countryUrlPrefix,
      queryParameters: {
        syan,
        farbId,
        categoryId,
        produktGruppe,
        markenName,
        searchterm,
        orderId,
        cartpos: cartpos ? cartpos.split(";") : [],
        inCart: inCart ? inCart.split(";") : [],
        useMock,
      },
      aktionsFlagsEnabled,
    };
  }

  protected renderRecommendation(recommendations: string): Promise<void> {
    return new Promise((resolve) => {
      const fragment = document
        .createRange()
        .createContextualFragment(recommendations);
      // https://developers.google.com/web/fundamentals/performance/rendering/optimize-javascript-execution#use_requestanimationframe_for_visual_changes
      window.requestAnimationFrame(() => {
        this.entdCarouselContainer?.replaceWith(fragment);
        // Replace the old (and now gone) reference
        this.entdCarouselContainer = this.querySelector<EntdCarouselContainer>(
          entdCarouselContainerTagName,
        );
        resolve();
      });
    });
  }
}
